module.exports = __webpack_public_path__ + "static/media/menu17.2ecc9d95.jpg";